import { Routes } from '@angular/router';
import { ClipPageComponent } from './clip-page/clip-page.component';
import { EpisodePageComponent } from './episode-page/episode-page.component';
import { ShowPageComponent } from './show-page/show-page.component';
import { ShowsIndexComponent } from './shows-index/shows-index.component';
import { ToolPageComponent } from './tool-page/tool-page.component';
import { ToolsIndexComponent } from './tools-index/tools-index.component';

/**
 * The Shows pages. An application mounts them at `/shows`, and `toolsRoutes` at `/tools`, and
 * says where in each parent route's data, which the children inherit:
 *
 * ```ts
 * {
 *   path: 'shows',
 *   data: { label: 'Shows', translationKey: 'navigation.shows', showsSection: { showsPath: '/shows', toolsPath: '/tools' } satisfies ShowsDefinition },
 *   loadChildren: () => import('@frontend/common').then((m) => m.showsRoutes),
 * }
 * ```
 *
 * `clips` is a reserved episode slug, so `/shows/{show}/clips/{clip}` never meets an episode.
 *
 * The routes nest as the breadcrumb reads: Shows › show › episode › clip. An episode's clip is a
 * child of its episode, and a show's or season's clip a child of the show (`clipPath`). A page
 * names the levels above it with `BreadcrumbService`, and its own with `PageTitleService`.
 */
export const showsRoutes: Routes = [
  { path: '', component: ShowsIndexComponent },
  {
    path: ':show',
    data: { label: 'Show', translationKey: null, labelSource: 'titleService' },
    children: [
      { path: '', component: ShowPageComponent },
      { path: 'clips/:clip', component: ClipPageComponent, data: { label: 'Clip', translationKey: null, labelSource: 'titleService' } },
      {
        path: ':episode',
        data: { label: 'Episode', translationKey: null, labelSource: 'titleService' },
        children: [
          { path: '', component: EpisodePageComponent },
          { path: 'clips/:clip', component: ClipPageComponent, data: { label: 'Clip', translationKey: null, labelSource: 'titleService' } },
        ],
      },
    ],
  },
];

export const toolsRoutes: Routes = [
  { path: '', component: ToolsIndexComponent },
  { path: ':tool', component: ToolPageComponent, data: { label: 'Tool', translationKey: null, labelSource: 'titleService' } },
];
